export default [
    {
        title: 'Coliseos',
        icon: 'BellIcon',
        route: 'brain-coliseos-list',
        requiresAdmin: true,
                requiresInvitado: true,
                requiresEncastador: false
        // tag: '2',
        // tagVariant: 'light-warning',
        
    },
];
